import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExport = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6666 7.99995H12.6666C12.8434 7.99995 13.013 8.04092 13.138 8.11385C13.263 8.18678 13.3333 8.2857 13.3333 8.38884V13.8333C13.3333 13.9364 13.263 14.0353 13.138 14.1083C13.013 14.1812 12.8434 14.2222 12.6666 14.2222H3.33325C3.15644 14.2222 2.98687 14.1812 2.86185 14.1083C2.73682 14.0353 2.66659 13.9364 2.66659 13.8333V8.38884C2.66659 8.2857 2.73682 8.18678 2.86185 8.11385C2.98687 8.04092 3.15644 7.99995 3.33325 7.99995H5.33325",
			stroke: "#006ADC",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9.77789L8 3.55566",
			stroke: "#006ADC",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.33325 5.33342L7.99992 2.66675L10.6666 5.33342",
			stroke: "#006ADC",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgExport);
export default ForwardRef;
